/* Colorland v10 storefront runtime (replaces the prototype's proto.js).
   - cart: real Shopify Ajax cart (/cart/add.js); Buy now posts the card form with return_to=/checkout
   - wishlist + recently viewed: handles kept on this device (spec §10.6), cards rendered by Shopify
     through /products/<handle>?view=cl10-card so they always show live price and stock
   - toast, header/tab cart badges, .reveal entrance, back-to-top */
(function () {
  'use strict';
  function T(k, en) { var d = window.CL10_T; return (d && d[k]) || en; }
  var R = (window.CL10 && window.CL10.routes) || { cart: '/cart', cartAdd: '/cart/add', root: '/' };
  var root = (R.root || '/').replace(/\/$/, '');

  function load(k, d) { try { var v = JSON.parse(localStorage.getItem(k)); return v == null ? d : v; } catch (e) { return d; } }
  function save(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  var CL = window.CL = window.CL || {};

  CL.money = function (cents) {
    var n = Math.round(cents) / 100;
    return 'AED ' + n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  };

  CL.toast = function (html) {
    var t = document.getElementById('cl-toast');
    if (!t) { t = document.createElement('div'); t.id = 'cl-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.innerHTML = html; t.classList.add('on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('on'); }, 2600);
  };

  CL.badges = function (count) {
    document.querySelectorAll('[data-cl-cart-link] .cl-badge').forEach(function (b) { b.textContent = count; b.hidden = !count; });
  };
  CL.refreshCart = function () {
    return fetch(root + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (!c) return null; CL.applyCart(c); return c; })
      .catch(function () { return null; }); // bot-check / 429 pages are HTML, not JSON
  };

  /* cart JSON → header/tab badges, in-cart state on product cards, cl:cart event */
  CL.lastCart = null;
  CL.applyCart = function (c) {
    if (!c || !c.items) return;
    // gift lines follow their items: a wrap count never exceeds the item's quantity, a wrap whose item left is removed,
    // and gift lines on their own (last product removed) are dropped so they never reach checkout alone
    var gifts = c.items.filter(function (i) { return (i.properties && i.properties._cl_gift) || i.handle === 'add-gift-wrapping'; });
    var upd = {}, hostQ = {};
    c.items.forEach(function (i) { if (gifts.indexOf(i) < 0) hostQ[i.variant_id] = (hostQ[i.variant_id] || 0) + i.quantity; });
    if (gifts.length && gifts.length === c.items.length) gifts.forEach(function (i) { upd[i.key] = 0; });
    else gifts.forEach(function (i) { if (i.properties && (i.properties._cl_gift === 'item' || i.properties._cl_gift === 'batt')) { var h = hostQ[i.properties._cl_for] || 0; if (i.quantity > h) upd[i.key] = h; } });
    if (Object.keys(upd).length && !CL._clearing) {
      CL._clearing = true;
      fetch(root + '/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: upd }) })
        .then(function (r) { return r.ok ? r.json() : null; }).then(function (nc) { CL._clearing = false; if (nc) CL.cartChanged(nc); }, function () { CL._clearing = false; });
    }
    CL.lastCart = c; CL.badges(c.item_count); CL.syncCards(c);
    document.dispatchEvent(new CustomEvent('cl:cart', { detail: c }));
  };
  // a change made outside the cart page / drawer code: update badges + cards, then let the cart page and drawer re-render
  CL.cartChanged = function (c) {
    if (c && c.items) CL.applyCart(c);
    document.dispatchEvent(new CustomEvent('cl:cart-changed', { detail: c }));
    return c;
  };
  function postJ(url, data) {
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) { return r.text().then(function (x) { var j = null; try { j = JSON.parse(x); } catch (e) {} if (!r.ok || !j) throw (j || { description: r.status === 429 ? T('cart_busy', 'Busy right now, please try again in a moment') : T('cart_update_failed_short', 'Could not update your cart') }); return j; }); });
  }
  function cartJS() { return fetch(root + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function ga(ev, data) { // GA4 custom events, same channel as the cart page (assets/cl10-cart.js)
    (function () { window.dataLayer = window.dataLayer || []; window.dataLayer.push(arguments); })('event', ev, Object.assign({ send_to: 'G-SJGLT1SPTV' }, data || {}));
  }
  function trackBuy(source, itemId) { try { ga('cl_buy_now_' + source, { item_id: itemId }); } catch (e) {} }

  /* per-item gift wrap (snippets/cl10-giftrow): own line per item, properties For / _cl_gift=item / _cl_for=<variant id> */
  function giftProps(row) { return { For: row.getAttribute('data-title'), _cl_gift: 'item', _cl_for: row.getAttribute('data-vid') }; }
  function giftRun(rows, job) {
    rows.forEach(function (r) { r.setAttribute('aria-busy', 'true'); });
    return job().then(cartJS).then(CL.cartChanged).catch(function (e) {
      rows.forEach(function (r) { r.removeAttribute('aria-busy'); });
      CL.toast((e && typeof e.description === 'string' && e.description) || T('cart_gift_update_failed', 'Couldn’t update gift wrap. Please try again.'));
      CL.refreshCart().then(function (c) { if (c) document.dispatchEvent(new CustomEvent('cl:cart-changed', { detail: c })); });
    });
  }
  document.addEventListener('change', function (e) {
    var cb = e.target.closest && e.target.closest('[data-gift-tog]'); if (!cb) return;
    var row = cb.closest('[data-gift-row]'), key = row.getAttribute('data-gkey');
    ga('cl_cart_gift', { gift_wrap: cb.checked, mode: row.getAttribute('data-mode') });
    giftRun([row], function () {
      return cb.checked
        ? postJ('/cart/add.js', { items: [{ id: Number(row.getAttribute('data-gvid')), quantity: Number(row.getAttribute('data-qty')), properties: giftProps(row) }] })
        : (key ? postJ('/cart/change.js', { id: key, quantity: 0 }) : Promise.resolve());
    });
  });
  /* per-item batteries (snippets/cl10-battrow): own line per item, properties For / _cl_gift=batt / _cl_for=<variant id> */
  document.addEventListener('change', function (e) {
    var cb = e.target.closest && e.target.closest('[data-batt-tog]'); if (!cb) return;
    var row = cb.closest('[data-batt-row]'), key = row.getAttribute('data-bkey');
    ga('cl_cart_batteries', { on: cb.checked });
    giftRun([row], function () {
      return cb.checked
        ? postJ('/cart/add.js', { items: [{ id: Number(row.getAttribute('data-bvid')), quantity: Number(row.getAttribute('data-qty')), properties: { For: row.getAttribute('data-title'), _cl_gift: 'batt', _cl_for: row.getAttribute('data-vid') } }] })
        : (key ? postJ('/cart/change.js', { id: key, quantity: 0 }) : Promise.resolve());
    });
  });
  function giftScope(el) { return el.closest('#cl10-cart,[data-cld-body]') || document; }
  function giftState(scope) {
    var s = { units: 0, wrapped: 0, add: 0, skipped: 0, bow: false, rows: [].slice.call(scope.querySelectorAll('[data-gift-row]')) };
    s.rows.forEach(function (r) { var q = +r.getAttribute('data-qty'), w = Math.min(q, +r.getAttribute('data-wraps') || 0); s.units += q; s.wrapped += w; s.add += (q - w) * (+r.getAttribute('data-gp') || 0); if (r.getAttribute('data-mode') === 'bow') s.bow = true; });
    scope.querySelectorAll('[data-gift-na]').forEach(function (n) { s.skipped += +n.getAttribute('data-gift-na') || 0; });
    return s;
  }
  CL.fillGiftPanels = function () {
    document.querySelectorAll('[data-gift-all]').forEach(function (p) {
      var s = giftState(giftScope(p)), all = s.units > 0 && s.wrapped >= s.units;
      p.hidden = s.units === 0; if (!s.units) return;
      var ar = (document.documentElement.lang || '').indexOf('ar') === 0;
      p.querySelector('[data-gift-all-t]').textContent = ar
        ? (all ? 'كل القطع جاهزة كهدية (' + s.units + ')' : 'اجعل كل القطع هدايا (' + s.units + ')')
        : (all ? 'All gift-ready (' + s.units + ')' : 'Make all ' + s.units + (s.units === 1 ? ' item a gift' : ' items gifts'));
      p.querySelector('[data-gift-all-s]').textContent = ar
        ? (s.bow ? 'ورق هدايا للألعاب، وشريط لألعاب الركوب.' : 'نغلّف كل لعبة على حدة.') + (s.skipped ? ' ' + s.skipped + ' لا يمكن تغليفها.' : '')
        : (s.bow ? 'Paper for toys, a bow for ride-ons.' : 'Each toy wrapped separately.') + (s.skipped ? ' ' + s.skipped + (s.skipped === 1 ? ' item can’t' : ' items can’t') + ' be wrapped.' : '');
      var b = p.querySelector('[data-gift-all-btn]'); b.textContent = all ? (ar ? 'إزالة' : 'Remove') : '+' + CL.money(s.add); b.setAttribute('data-on', all ? '1' : '');
    });
  };

  /* cart cross-sell bars (snippets/cl10-xsell): add with a source property so each bar's sales can be counted */
  var xseen = {};
  CL.xsellViews = function () {
    document.querySelectorAll('[data-xbar]').forEach(function (b) { var k = b.getAttribute('data-xbar'); if (!xseen[k]) { xseen[k] = 1; ga('cl_xsell_view', { bar: k, xsell_count: +b.getAttribute('data-count') || 0 }); } });
  };

  function lineFor(c, vid) {
    var q = 0, key = null;
    (c && c.items || []).forEach(function (i) { if (String(i.variant_id) === String(vid) && !(i.properties && i.properties._cl_gift)) { q += i.quantity; if (!key) key = i.key; } });
    return { qty: q, key: key };
  }
  CL.syncCards = function (c) {
    c = c || CL.lastCart; if (!c) return;
    document.querySelectorAll('.card[data-vid] [data-cl-cart]').forEach(function (b) {
      var card = b.closest('.card'), l = lineFor(c, card.getAttribute('data-vid'));
      var badge = b.querySelector('.cl10-inq');
      if (l.qty > 0) {
        if (!badge) { badge = document.createElement('span'); badge.className = 'cl10-inq'; b.appendChild(badge); }
        badge.textContent = l.qty; b.classList.add('in');
        b.setAttribute('aria-label', T('common_in_cart_change', '{n} in cart, change quantity').replace('{n}', l.qty));
      } else {
        if (badge) badge.remove(); b.classList.remove('in');
        b.setAttribute('aria-label', T('common_add_title_to_cart', 'Add {title} to cart').replace('{title}', (card.querySelector('.name') || {}).textContent || ''));
      }
      var st = card.querySelector('.cl10-step'); if (st) paintStep(st, l.qty, card);
    });
  };

  /* in-card quantity stepper (live theme parity): tap the cart icon of an item already in the cart */
  function paintStep(st, q, card) {
    if (q < 1) { st.remove(); return; }
    var max = Number(card.getAttribute('data-max') || 0);
    st.querySelector('span').textContent = q;
    var minus = st.querySelector('[data-step="-1"]');
    minus.innerHTML = q === 1 ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg>' : '−';
    minus.setAttribute('aria-label', q === 1 ? T('common_remove_from_cart', 'Remove from cart') : T('common_decrease_qty', 'Decrease quantity'));
    st.querySelector('[data-step="1"]').disabled = !!(max && q >= max);
  }
  function openStep(btn, kb) {
    var card = btn.closest('.card'), form = btn.closest('form'); if (!card || !form) return;
    var st = card.querySelector('.cl10-step');
    if (!st) {
      st = document.createElement('div'); st.className = 'cl10-step'; st.setAttribute('role', 'group'); st.setAttribute('aria-label', T('common_qty_in_cart', 'Quantity in cart'));
      st.innerHTML = '<button type="button" data-step="-1"></button><span aria-live="polite"></span><button type="button" data-step="1" aria-label="' + T('common_increase_qty', 'Increase quantity') + '">+</button>';
      form.appendChild(st);
    }
    paintStep(st, lineFor(CL.lastCart, card.getAttribute('data-vid')).qty, card);
    armCollapse(st);
    if (kb) st.querySelector('[data-step="1"]').focus({ preventScroll: true }); // keyboard users land on "+"; taps show no focus ring
  }
  // closes 2.5 s after the last tap (a mouse resting on it keeps it open); focus returns to the cart icon
  var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  function armCollapse(st) {
    clearTimeout(st._t);
    if (!st._m && fine) { st._m = 1; st.addEventListener('mouseleave', function () { armCollapse(st); }); }
    st._t = setTimeout(function () {
      if (fine && st.matches(':hover')) return armCollapse(st);
      var had = st.contains(document.activeElement), form = st.parentNode; st.remove();
      if (had && form) { var b = form.querySelector('[data-cl-cart]'); if (b) b.focus({ preventScroll: true }); }
    }, 2500);
  }
  function stepBy(b) {
    var st = b.closest('.cl10-step'), card = b.closest('.card'), l = lineFor(CL.lastCart, card.getAttribute('data-vid'));
    if (!l.key) return;
    var q = Math.max(0, l.qty + Number(b.getAttribute('data-step')));
    st.setAttribute('aria-busy', 'true'); armCollapse(st);
    fetch(root + '/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: l.key, quantity: q }) })
      .then(function (r) { return r.ok ? r.json() : r.text().then(function (x) { var j = null; try { j = JSON.parse(x); } catch (e) {} throw (j || {}); }); })
      .then(function (c) { st.removeAttribute('aria-busy'); CL.applyCart(c); if (q === 0) CL.toast(T('common_removed_from_cart', 'Removed from cart')); })
      .catch(function (e) { st.removeAttribute('aria-busy'); CL.toast((e && typeof e.description === 'string' && e.description) || T('cart_update_failed_short', 'Could not update your cart')); });
  }

  CL.add = function (variantId, qty, opts) {
    opts = opts || {};
    var body = { items: [{ id: Number(variantId), quantity: qty || 1, properties: opts.properties || {} }] };
    return fetch(root + '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) {
      return r.text().then(function (t) {
        var j = null; try { j = JSON.parse(t); } catch (e) {}
        if (!r.ok || !j) throw (j || { description: r.status === 429 ? T('cart_busy', 'Busy right now, please try again in a moment') : T('common_could_not_add', 'Could not add this item') });
        return j;
      });
    })
      .then(function (j) {
        if (!opts.silent && CL.openCart && CL.drawerEnabled && CL.drawerEnabled()) { CL.refreshCart(); CL.openCart(); }
        else { CL.refreshCart(); if (!opts.silent) CL.toast(T('common_added_to_cart', 'Added to cart') + ' · <a href="' + R.cart + '">' + T('common_view_cart', 'View cart') + '</a>'); }
        return j;
      })
      .catch(function (err) {
        CL.toast((err && typeof err.description === 'string' && err.description) || T('common_could_not_add', 'Could not add this item'));
        throw err;
      });
  };
  CL.buyNow = function (variantId, qty) {
    return CL.add(variantId, qty, { silent: true }).then(function () { location.href = root + '/checkout'; });
  };

  /* wishlist (device only) */
  CL.wish = function () { return load('cl-wish', []); };
  CL.isWished = function (h) { return CL.wish().indexOf(h) > -1; };
  CL.toggleWish = function (h) {
    var w = CL.wish(), i = w.indexOf(h);
    if (i > -1) w.splice(i, 1); else w.unshift(h);
    save('cl-wish', w.slice(0, 100));
    var url = (window.CL10 && window.CL10.wishlistUrl) || '/pages/wishlist';
    CL.toast(i > -1 ? T('common_removed_wishlist', 'Removed from wishlist') : T('common_saved_wishlist', 'Saved to wishlist') + ' · <a href="' + url + '">' + T('common_view', 'View') + '</a>');
    CL.syncWish();
    document.dispatchEvent(new CustomEvent('cl:wish', { detail: CL.wish() }));
    return i < 0;
  };
  CL.addWish = function (h) { var w = CL.wish(); if (w.indexOf(h) < 0) { w.unshift(h); save('cl-wish', w.slice(0, 100)); CL.syncWish(); } };
  CL.syncWish = function () {
    var w = CL.wish();
    document.querySelectorAll('[data-wish]').forEach(function (b) { b.setAttribute('aria-pressed', w.indexOf(b.getAttribute('data-wish')) > -1 ? 'true' : 'false'); });
    document.querySelectorAll('[data-wish-count]').forEach(function (el) { el.textContent = w.length; });
  };

  /* recently viewed (device only) */
  CL.recent = function () { return load('cl-recent', []); };
  CL.pushRecent = function (h) { var r = CL.recent().filter(function (x) { return x !== h; }); r.unshift(h); save('cl-recent', r.slice(0, 20)); };

  /* server-rendered card for a handle (templates/product.cl10-card.liquid) */
  var cardCache = {};
  CL.cardHTML = function (handle, view) {
    var key = handle + '|' + (view || 'cl10-card');
    if (!cardCache[key]) {
      cardCache[key] = fetch(root + '/products/' + encodeURIComponent(handle) + '?view=' + (view || 'cl10-card'))
        .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    }
    return cardCache[key];
  };
  CL.renderHandles = function (container, handles, view) {
    return Promise.all(handles.map(function (h) { return CL.cardHTML(h, view); })).then(function (list) {
      container.innerHTML = list.join('');
      CL.syncWish();
      return list.filter(Boolean).length;
    });
  };

  /* product JSON (price/stock/images) for interactive blocks */
  var jsonCache = {};
  CL.productJSON = function (handle) {
    if (!jsonCache[handle]) jsonCache[handle] = fetch(root + '/products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return jsonCache[handle];
  };

  CL.track = function (name, params) { try { var dl = (window.dataLayer = window.dataLayer || []); dl.push(Object.assign({ event: name }, params || {}));
    // search_* and delivery_* have no GTM trigger: send them to GA4 directly (gtag form, same channel as ga() above)
    if (/^(search_|delivery_)/.test(name)) (function () { dl.push(arguments); })('event', name, Object.assign({ send_to: 'G-SJGLT1SPTV' }, params || {})); } catch (e) {} };

  /* clicks: card cart icon, generic add buttons, wishlist hearts */
  document.addEventListener('click', function (e) {
    var gs = e.target.closest('[data-gift-step],[data-gift-all-btn],[data-xsell-add]');
    if (gs) {
      e.preventDefault();
      if (gs.hasAttribute('data-xsell-add')) {
        if (gs.classList.contains('done') || gs.getAttribute('aria-busy')) return;
        var bar = gs.getAttribute('data-bar'), props = { _cl_src: 'cart_' + bar };
        if (gs.getAttribute('data-theme')) props._cl_theme = gs.getAttribute('data-theme');
        gs.setAttribute('aria-busy', 'true'); gs.textContent = T('cart_adding', 'Adding…');
        ga('cl_xsell_add', { bar: bar, xsell_position: [].indexOf.call(gs.closest('.cl10-xrow').children, gs.closest('.cl10-xc')) + 1 });
        postJ('/cart/add.js', { items: [{ id: Number(gs.getAttribute('data-xsell-add')), quantity: 1, properties: props }] })
          .then(function () { gs.removeAttribute('aria-busy'); gs.classList.add('done'); gs.textContent = T('cart_added', 'Added ✓'); return cartJS(); })
          .then(CL.cartChanged)
          .catch(function (x) { gs.removeAttribute('aria-busy'); gs.textContent = T('cart_add', 'Add'); CL.toast((x && typeof x.description === 'string' && x.description) || T('cart_not_available', 'Not available')); });
        return;
      }
      if (gs.hasAttribute('data-gift-step')) {
        var row = gs.closest('[data-gift-row]'), w = +row.getAttribute('data-wraps'), q = +row.getAttribute('data-qty');
        var n = Math.max(1, Math.min(q, w + Number(gs.getAttribute('data-gift-step'))));
        if (n !== w) giftRun([row], function () { return postJ('/cart/change.js', { id: row.getAttribute('data-gkey'), quantity: n }); });
        return;
      }
      var sc = giftScope(gs), st = giftState(sc), on = gs.getAttribute('data-on') === '1', upd = {}, adds = [];
      st.rows.forEach(function (r) {
        var k = r.getAttribute('data-gkey'), q = +r.getAttribute('data-qty');
        if (on) { if (k) upd[k] = 0; }
        else if (k) upd[k] = q;
        else adds.push({ id: Number(r.getAttribute('data-gvid')), quantity: q, properties: giftProps(r) });
      });
      ga('cl_cart_gift', { all: !on });
      var panel = gs.closest('[data-gift-all]'); if (panel) panel.setAttribute('aria-busy', 'true');
      giftRun(st.rows, function () {
        return (Object.keys(upd).length ? postJ('/cart/update.js', { updates: upd }) : Promise.resolve())
          .then(function () { return adds.length ? postJ('/cart/add.js', { items: adds }) : null; });
      }).then(function () { if (panel) panel.removeAttribute('aria-busy'); });
      return;
    }
    var sb = e.target.closest('.cl10-step [data-step]');
    if (sb) { e.preventDefault(); stepBy(sb); return; }
    var el = e.target.closest('[data-cl-cart],[data-add-variant],[data-wish],[data-buy-variant]');
    if (!el) return;
    if (el.hasAttribute('data-cl-cart') && el.classList.contains('in') && el.closest('.card')) { e.preventDefault(); openStep(el, e.detail === 0); return; }
    if (el.hasAttribute('data-wish')) { e.preventDefault(); el.setAttribute('aria-pressed', CL.toggleWish(el.getAttribute('data-wish')) ? 'true' : 'false'); return; }
    if (el.hasAttribute('data-buy-variant')) { e.preventDefault(); trackBuy('quick', el.getAttribute('data-buy-variant')); el.setAttribute('aria-busy', 'true'); CL.buyNow(el.getAttribute('data-buy-variant'), Number(el.getAttribute('data-qty') || 1)).catch(function () { el.removeAttribute('aria-busy'); }); return; }
    var vid = el.getAttribute('data-add-variant');
    if (!vid) { var f = el.closest('form'); vid = f && f.querySelector('[name=id]') && f.querySelector('[name=id]').value; }
    if (!vid) return;
    e.preventDefault();
    el.setAttribute('aria-busy', 'true');
    CL.add(vid, Number(el.getAttribute('data-qty') || 1)).then(function () { el.removeAttribute('aria-busy'); }, function () { el.removeAttribute('aria-busy'); });
  });

  /* Buy now on cards: add via Ajax then go to checkout (form posts natively if JS fails) */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches('form[data-cl-add]')) return;
    var id = f.querySelector('[name=id]');
    if (!id) return;
    e.preventDefault();
    var btn = f.querySelector('[data-cl-buy]'); if (btn) btn.setAttribute('aria-busy', 'true');
    trackBuy('card', id.value);
    CL.buyNow(id.value, Number((f.querySelector('[name=quantity]') || {}).value || 1)).catch(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });

  /* entrance reveal */
  function reveal(rootEl) {
    var els = (rootEl || document).querySelectorAll('.reveal:not(.in)');
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) { els.forEach(function (x) { x.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (x) { io.observe(x); });
  }
  CL.reveal = reveal;

  /* back to top */
  function totop() {
    var b = document.getElementById('totop');
    if (!b) return;
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); });
    addEventListener('scroll', function () { b.classList.toggle('on', scrollY > 1400); }, { passive: true });
  }

  function init() {
    reveal(); totop(); CL.syncWish(); CL.fillGiftPanels(); CL.xsellViews();
    /* cards added later (feed, rails, search) get their heart state too */
    if ('MutationObserver' in window) { var mt; new MutationObserver(function () { clearTimeout(mt); mt = setTimeout(function () { CL.syncWish(); CL.syncCards(); CL.fillGiftPanels(); CL.xsellViews(); }, 150); }).observe(document.body, { childList: true, subtree: true }); }
    if (window.CL10 && window.CL10.product) CL.pushRecent(window.CL10.product);
    if (window.CL10 && Number(window.CL10.cartCount) > 0) CL.refreshCart(); // in-cart state on cards
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  addEventListener('pageshow', function (e) { if (e.persisted) CL.refreshCart(); });
})();
